import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'bb-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
